import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { BRAND } from "@/lib/brand";
import { useMobilI18n } from "@/lib/mobilI18n";

const fade = (delay) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] },
});

export default function MobilHero() {
  const { m } = useMobilI18n();
  return (
    <section data-testid="mobil-hero" className="relative min-h-[92vh] flex items-end overflow-hidden bg-[#1c2421]">
      <motion.img
        src={BRAND.mobilPhotos.hero}
        alt={m.name}
        initial={{ scale: 1.08 }}
        animate={{ scale: 1 }}
        transition={{ duration: 2.2, ease: "easeOut" }}
        className="absolute inset-0 w-full h-full object-cover object-[center_60%]"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#1c2421]/55 via-[#1c2421]/35 to-[#1c2421]/90" />
      <div className="relative w-full max-w-7xl mx-auto px-6 md:px-12 pb-16 md:pb-24 pt-40">
        <motion.p {...fade(0.1)} className="text-[#E2C9A0] text-[10px] md:text-xs uppercase tracking-[0.4em] font-medium" data-testid="mobil-hero-eyebrow">
          {m.hero.eyebrow}
        </motion.p>
        <motion.h1 {...fade(0.25)} className="mt-6 font-display text-[#fdfcf9] text-4xl sm:text-5xl lg:text-7xl leading-[1.02] tracking-[-0.02em] max-w-4xl" data-testid="mobil-hero-title">
          {m.hero.titleA} <em className="text-[#E2C9A0] font-display italic">{m.hero.titleHl}</em> {m.hero.titleB}
        </motion.h1>
        <motion.p {...fade(0.4)} className="mt-6 text-[#fdfcf9]/85 text-base md:text-lg leading-relaxed max-w-xl">
          {m.hero.desc}
        </motion.p>
        <motion.div {...fade(0.55)} className="mt-10 flex flex-wrap items-center gap-4">
          <a
            href="#disponibilitat-externs"
            data-testid="mobil-hero-cta-calendar"
            className="group inline-flex items-center gap-3 px-8 py-4 rounded-full bg-[#E2C9A0] text-[#2e5949] hover:bg-[#fdfcf9] transition-colors text-sm uppercase tracking-[0.18em] font-medium"
          >
            {m.hero.ctaPrimary}
            <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          </a>
          <a
            href="#serveis"
            data-testid="mobil-hero-cta-services"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-full border border-[#fdfcf9]/40 text-[#fdfcf9] hover:bg-[#fdfcf9]/10 transition-colors text-sm uppercase tracking-[0.18em] font-medium"
          >
            {m.hero.ctaSecondary}
          </a>
        </motion.div>
      </div>
    </section>
  );
}
